import React, { useCallback, useEffect, useState } from 'react';
import ReactInputVerificationCode from 'react-input-verification-code';
import styled from 'styled-components';

const StyledSeconds = styled.button`
  font-family: Roboto, sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0;
  margin-top: 30px;
  text-align: center;
  cursor: pointer;
  background: none;
  border: 0;
`;

const StyledError = styled.div`
  font-family: Open Sans, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0;
  text-align: left;
  color: #f20606;
  margin: 20px 0 0 10px;
`;

const StyledReactInputVerificationCode = styled.div`
  display: flex;

  --ReactInputVerificationCode-itemWidth: 40px;
  --ReactInputVerificationCode-itemHeight: 48px;
  --ReactInputVerificationCode-itemSpacing: 8px;

  .ReactInputVerificationCode__container {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
  }

  .ReactInputVerificationCode__item {
    width: 11%;
    margin: 0 10px;
    font-size: 16px;
    font-weight: 500;
    color: #000000;
    border-radius: 0;
    background: inherit;
    border-bottom: ${(props) => (props?.isInvalid ? '1px solid #F20606' : '1px solid #397EF3')};
    box-shadow: none;
  }

  .ReactInputVerificationCode__item.is-active {
    box-shadow: none;
    border: 1px solid #397ef3;
  }
`;

const VerificationCode = ({
  error,
  setError,
  otp,
  setOtp,
  isLoading,
  resendCode,
  isResendCodeLoading,
}) => {
  const [seconds, setSeconds] = useState(30);

  const resendCodeTime = useCallback(() => {
    const intervalId = setInterval(() => {
      setSeconds((_seconds) => {
        if (!_seconds) {
          clearInterval(intervalId);
          return 0;
        }
        return _seconds - 1;
      });
    }, 1000);
  }, [setSeconds]);

  useEffect(() => {
    resendCodeTime();
  }, [resendCodeTime]);

  const handleResendCode = () => {
    resendCode();
    setSeconds(30);
    resendCodeTime();
  };

  const handleOnChange = (newValue) => {
    setOtp(newValue);

    if (newValue !== '') {
      setError(null);
    }
  };

  const isSubmitBtnDisabled = isLoading || otp.length < 6 || isResendCodeLoading;
  const isResendBtnDisabled = !!seconds || isResendCodeLoading;

  return (
    <>
      <StyledReactInputVerificationCode isInvalid={error}>
        <ReactInputVerificationCode
          value={otp}
          placeholder={null}
          length={6}
          onChange={handleOnChange}
        />
      </StyledReactInputVerificationCode>

      {error && <StyledError>Wrong Verification Code</StyledError>}

      <button
        className="btn"
        type="submit"
        disabled={isSubmitBtnDisabled}
        onClick={() => setError(false)}
      >
        {isLoading || isResendCodeLoading ? 'Loading...' : 'Continue'}
      </button>

      <StyledSeconds
        disabled={isResendBtnDisabled}
        onClick={handleResendCode}
        style={{ color: isResendBtnDisabled ? '#A6B0CF' : '#397CF3' }}
      >
        {seconds ? `Resend the code ${seconds}s` : 'Resend the code'}
      </StyledSeconds>
    </>
  );
};

export default VerificationCode;
